import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import React from 'react';
import FuseLoading from '@fuse/core/FuseLoading';

type IProps = {
  open: boolean;
  handleClose: () => void;
  title?: string;
  titleIcon?: React.ReactNode;
  titleClassName?: string;
  disableTittle?: boolean;
  closeButtonClassName?: string;
  children: React.ReactNode;
  size?: DialogProps['maxWidth'];
  loading?: boolean;
  hideCloseButton?: boolean;
  onClose?: (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => void;
  headerActions?: React.ReactNode; // <-- new prop
} & DialogProps;

const AppSimpleDialog = (props: IProps) => {
  const {
    open,
    handleClose,
    children,
    size = 'sm',
    title,
    titleIcon,
    titleClassName,
    closeButtonClassName,
    disableTittle,
    loading,
    hideCloseButton,
    onClose,
    headerActions,
    ...rest
  } = props;

  return (
    <Dialog open={open} onClose={onClose || handleClose} maxWidth={size} fullWidth {...rest}>
      {loading && (
        <div className="fixed inset-0 flex bg-[#0000008a] z-50 [&>div>p]:text-black">
          <FuseLoading />
        </div>
      )}

      {!disableTittle && (
        <DialogTitle
          id="draggable-dialog-title"
          className={`w-full flex justify-between items-center ${titleClassName}`}
        >
          <span className="flex items-center gap-8">
            {titleIcon}
            <span>{title}</span>
          </span>
          <span className="flex items-center gap-8">
            {headerActions}
            {!hideCloseButton && (
              <button type="button" onClick={handleClose} className={`${closeButtonClassName}`}>
                <FuseSvgIcon>material-outline:clear</FuseSvgIcon>
              </button>
            )}
          </span>
        </DialogTitle>
      )}

      {children}
    </Dialog>
  );
};

export default AppSimpleDialog;
